// 新零售绩效提成核算
import http from "@/utils/http";
let oA = "/oaApi/nvc/public";
export default {
  // 第一步：导入附件，把附件上传到服务器
  importExcel: (data) =>
    http.post(`${oA}/api/kpi/index/upload`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  //第二步：将上面返回的地址再传参到这个接口从而实现效果
  importTableData: (data) =>
    http.post(`${oA}/api/kpi/index/importData`, data),

  // 导出
  downloadData: (data) =>
    http.post(`${oA}/api/kpi/index/exportData`, data),
  // 下载模板
  downTemplate: (data) =>
    http.post(`${oA}/api/kpi/index/template`, data),
  // 获取新零售销售数据以及待办
  getRetailData: (data) =>
    http.post(`${oA}/api/kpi/index/taskList`, data),
  // 任务列表详情
  getRetailDetail: (data) =>
      http.post(`${oA}/api/kpi/index/taskDetail`, data),

  getKpiList: (data) => http.post(`${oA}/api/kpi/index/lst`, data),


  // 确认数据
  confirmData: (data) => http.post(`${oA}/api/kpi/index/confirm`, data),
  // 修改数据
  editData: (data) => http.post(`${oA}/api/kpi/index/update`, data),

};
